import { ISelectedGccParent } from "@/components/Marketplace/GCC/Buy/BuyFromProfile";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: {
    selectedGcc: ISelectedGccParent;
    gccActivated: number
} = {
    selectedGcc: {
        subjectAddress: "",
        subjectData: {
            profilePic: "",
            displayName: "",
            handle: "",
            outId: 0
        }
    },
    gccActivated: 0
};
export const PageSlice = createSlice({
    name: "page_slice",
    initialState,
    reducers: {
        setBuyFromProfilePage: (state, action: PayloadAction<{
            selectedGcc: ISelectedGccParent;
            gccActivated: number
        }>) => {
            state.selectedGcc = action.payload.selectedGcc;
            state.gccActivated = action.payload.gccActivated;
        },
    },
});
export const {
    setBuyFromProfilePage
} = PageSlice.actions;

export default PageSlice.reducer;